"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_link_context_1 = require("apollo-link-context");
function createLanguageLink(getLang) {
    return apollo_link_context_1.setContext(function (op, prevContext) {
        var prevHeaders = prevContext && prevContext.headers ? prevContext.headers : {};
        return {
            headers: __assign(__assign({}, prevHeaders), { 'X-User-Language': (op.context && op.context.userLanguage) || getLang() }),
        };
    });
}
exports.createLanguageLink = createLanguageLink;
//# sourceMappingURL=createLanguageLink.js.map